angular.module('CaresApp').filter('caseSeq', function() {
  return function(input) {
    if (input && !isNaN(input)) {
      return (`${1e6}${input}`).slice(-6);
    }
    return null;
  };
});

